import { configureStore } from '@reduxjs/toolkit';
import loginReducer from '../modules/login/redux/LoginSlice';
import registerReducer from '../modules/register/redux/RegisterSlice';
import auctionReducer from '../modules/auction/redux/AuctionSlice';
import forgotPasswordReducer from '../modules/forgot-password/redux/ForgotPasswordSlice';
import accountApi from './api/AccountApi';
import systemApi from './api/SystemApi';
import fileApi from './api/FileApi';
import productApi from './api/ProductApi';
import bidApi from './api/BidApi';
import contractApi from './api/ContractApi';
import publicApi from './api/PublicApi'
import dashboardApi from './api/DashboardApi';

export const store = configureStore({
    reducer: {
        login: loginReducer,
        auction: auctionReducer,
        register: registerReducer,
        forgotPassword: forgotPasswordReducer,
        [accountApi.reducerPath]: accountApi.reducer,
        [systemApi.reducerPath]: systemApi.reducer,
        [fileApi.reducerPath]: fileApi.reducer,
        [productApi.reducerPath]: productApi.reducer,
        [bidApi.reducerPath]: bidApi.reducer,
        [contractApi.reducerPath]: contractApi.reducer,
        [publicApi.reducerPath]: publicApi.reducer,
        [dashboardApi.reducerPath]: dashboardApi.reducer,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware().concat(
            accountApi.middleware,
            systemApi.middleware,
            fileApi.middleware,
            productApi.middleware,
            bidApi.middleware,
            contractApi.middleware,
            publicApi.middleware,
            dashboardApi.middleware,
        )
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch